<template>
  <of-dialog
    :title="formTitle"
    :width="width"
    @onCancel="cancel"
    @onConfirm="confirm"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="120px"
        :model="dataForm"
        :rules="editFormRules"
        :disabled="isDisabled"
      >
        <el-form-item label="标题：" prop="Title">
          <el-input
            placeholder="请输入标题"
            v-model="dataForm.Title"
            clearable
          ></el-input>
        </el-form-item>


        <el-form-item label="开放日期：" prop="OpenTime">
          <div style="display:flex">
          <div style="flex:0.7">

              <el-date-picker
                v-model="dataForm.OpenTime"
                type="date"
                value-format="timestamp"
                placeholder="选择日期时间"
              ></el-date-picker>

          </div>
        <div style="flex:1;display:flex;">

         <el-time-select
          class="el-time-input"
          v-model="dataForm.TimeStart"
          :picker-options="{
            start: '07:00',
            step: '02:00',
            end: '23:00'
          }"
          placeholder="开始时间">
        </el-time-select>
        <el-time-select
         class="el-time-input"
          v-model="dataForm.TimeEnd"
          :picker-options="{
            start: '07:00',
            step: '02:00',
            end: '23:00',
            minTime: dataForm.TimeStart
            }"
          placeholder="结束时间">
        </el-time-select>

    </div>
     </div>
    </el-form-item>
      <el-form-item label="体验馆活动：" prop="TrainTitle">
          <el-select v-model="dataForm.TrainTitle" placeholder="请选择" disabled>
            <el-option
              v-for="item in libraryList"
              :key="item.Id"
              :label="item.Title"
              :value="item.Title"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null
    },
    formTitle: {
      type: String,
      default: ""
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      //表单规则
      editFormRules: {
        Title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
        TrainTitle: [
          { required: true, message: "体验馆活动不能为空", trigger: "blur" }
        ],
        OpenTime: [
          { required: true, message: "开放日期不能为空", trigger: "blur" }
        ],
        CostDescription: [
          { required: true, message: "开放时间描述不能为空", trigger: "blur" }
        ]
      },
      isdisabled: false,
      width: "48%",
      type: 3,
      libraryList: []
    };
  },
  components: {
    OfDialog
  },
  mounted() {
    this.getLibraryOption();
  },
  computed: {},
  methods: {
    cancel() {
      this.$emit("formCallBack", null);
    },
    //提交
    confirm() {
      let vm = this
      this.$refs.form.validate(valid => {
        if (valid) {
          this.isConfirm = true;
          this.libraryList.forEach(item => {
            if (item.Title == this.dataForm.TrainTitle) {
              this.dataForm.TrainId = item.Id;
              return;
            }
          });

          if(vm.dataForm.TimeEnd===null||vm.dataForm.TimeStart===null){
            return vm.$message.error("请选择时间")
          }
          let params = Object.assign({}, vm.dataForm);
          params.OpenTime=params.OpenTime / 1000;
          api.SaveLibraryPeriods(params)
            .then(rep => {
              vm.isConfirm = false;
              if (rep.data.Code === 0) {
                vm.$message({
                  message: "提交成功",
                  type: "success"
                });
                vm.$emit("formCallBack", params);
              } else {
                vm.$message({
                  message: rep.data.Message,
                  type: "error"
                });
              }
            })
            .catch(e => {
              vm.isConfirm = false;
              vm.$message({
                message: e.toString(),
                type: "error"
              });
            });
        }
      });
    },
    //获取所有体验馆活动
    getLibraryOption() {
      let params={Type:this.type}
      api.QueryAllTrainByType(params).then(rep => {
        if (rep.data.Code === 0) {
          this.libraryList = rep.data.Data;
          this.dataForm.TrainTitle=rep.data.Data[0].Title
        }
      });
    }
  },
};
</script>


<style scoped>
.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-time-input{
  width: 150px!important;
  margin-left: 10px;
}
</style>

